<div class="modal-header bg-soft-info p-3">
    <h5 class="modal-title" id="exampleModalLabel" i18n="@@">
        {{model.title}}</h5>

    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>
<div class="card-body p-4">

    <div class="text-center mb-4">

        <h4 class="mb-2">{{model.title}}</h4>

        <p class="text-muted mb-4">
            <span *ngFor="let role of model.createdBy?.roles">{{role}}, </span>
        </p>
        <div class="d-flex align-items-center justify-content-center flex-wrap gap-2">
            <span *ngFor="let tag of model.tags" class="badge coloredTextArea blue text-primary">{{tag}}</span>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-lg-2">
            <h6 class="pb-1">Contributed By:</h6>
            <div class="d-flex gap-2 mb-3">
                <div class="flex-shrink-0">
                    <img [src]="profileImageURL" class="rounded-circle avatar-sm img-thumbnail user-profile-image"
                        alt="user-profile-image">
                </div>
                <div class="flex-grow-1">
                    <h5 class="mb-1">{{model.createdByName}}</h5>
                    <!-- <p class="mb-2">
                        <span *ngFor="let role of creator.roles">{{role}}, </span>
                    </p> -->

                    <p class="text-muted mb-0">{{model.publishDate| amTimeAgo:true}} </p>
                </div>
            </div>

        </div>
        <div class="col-lg-10">
            <app-rich-text-displayer [textToDisplay]="model.blogText"></app-rich-text-displayer>
        </div>
    </div>
    <div>
        <div class="hstack gap-2 justify-content-end">
            <button type="submit" class="btn btn-danger" i18n="@@" (click)="markAsRead()">Dismiss</button>
        </div>
    </div>